import React from 'react';
import { connect } from 'react-redux';
import IMenuPanelState from 'src/common/interfaces/states/IMenuPanelState';
import { AppState } from 'src/common/redux/configure-store';
import { MenuPanelActions } from 'src/common/redux/reducers/menu-panel-reducer';
import MenuPanel from '../menu-panel';

type Props = IMenuPanelWrapper & IMenuPanelWrapperState & typeof mapDispatchToProps;

const MenuPanelWrapper: React.FC<Props> = (props): JSX.Element => {
  return (
    <MenuPanel
      isOpened={props.menuPanelState.visible}
      menuMode={props.menuMode}
      toggleMenuDisplay={props.toggleMenuPanelDisplay}
      displayName={props.displayName}
      touchPointId={props.touchPointId}
      isActiveTransaction={props.isActiveTransaction}
      registerModeActive={props.registerModeActive}
    />
  );
};

interface IMenuPanelWrapper {
  menuMode: 'home' | 'login';
}

interface IMenuPanelWrapperState {
  menuPanelState: IMenuPanelState;
  displayName: string;
  touchPointId: string;
  isActiveTransaction: boolean;
  registerModeActive: boolean;
}

const mapStateToProps = (state: AppState): IMenuPanelWrapperState => ({
  menuPanelState: state.menuPanel,
  displayName: state.user.displayName ?? '',
  touchPointId: state.touchPoint.touchPointConfiguration.touchPointId ?? '',
  isActiveTransaction: !!state.transaction.transactionId,
  registerModeActive: !state.touchPoint.touchPointConfiguration.touchPointId,
});

const mapDispatchToProps = {
  toggleMenuPanelDisplay: MenuPanelActions.toggle,
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuPanelWrapper);
